import * as React from 'react';
import { useContext, useState } from 'react';
import {
  Button,
  Dialog,
  FormControl,
  Grid,
  TextField,
  Typography
} from '@mui/material';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/env';
import { OrganisationContext } from '../../App';
import { DialogRoot } from './DialogRoot';
import Box from '@mui/material/Box';
import { TitleDialog } from './TitleDialog';

export const EditVideoRequest = ({ open, handleClose, video }) => {
  const [message, setMessage] = useState<string>();
  const [postSubmit, setPostSubmit] = useState<boolean>();

  const { selectedOrganisation } = useContext(OrganisationContext);
  const onSave = async () => {
    await axios.post(`${getApiBaseUrl()}/video-clip/${selectedOrganisation}/edit-video-request`, {
      media_id: video.media_id,
      instruction: message,
      user_email: localStorage.getItem('user_email')
    }).catch(() => setPostSubmit(false));
    setPostSubmit(true);
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={'sm'}>
      <DialogRoot handleClose={handleClose}>
         <TitleDialog>Edit request</TitleDialog>
        <Box sx={{ pl: 4, pr: 4, pb: 4 }}>
          <Grid container spacing={2} style={{ marginTop: 0 }}>
            {postSubmit !== undefined && <Grid item xs={12}>
              {postSubmit && <Typography color={'green'} fontSize={'12px'}>Instruction successfully
                submitted</Typography>}
              {!postSubmit &&
                <Typography color={'red'} fontSize={'12px'}>Sorry, this instruction has
                  failed.</Typography>}
            </Grid>}
            <Grid item xs={12}>
              <Typography fontSize={'12px'}>Media id: {video.media_id}</Typography>
              <Typography fontSize={'12px'}>Title: {video.title}</Typography>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <TextField
                  multiline
                  minRows={5}
                  id="instruction"
                  label="Message / instruction"
                  variant="outlined"
                  type={'text'}
                  onChange={({ target: { value } }) => setMessage(value)}
                  value={message}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Grid container justifyContent={'flex-end'}>
                <Button color="primary" variant="contained" onClick={() => onSave()}>
                  Send request
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </DialogRoot>
    </Dialog>
  );
};
